import {Async, Loaded, Loading} from 'Core/models/Async';

export class UnassignedPackageModel {
  public readonly key = 'UnassignedPackageModel';
}

export type PackageModel = Async<object[]> | UnassignedPackageModel;

type MatchPackageModelOptions<TReturn> = {
  Loading: () => TReturn;
  Loaded: (packages: object[]) => TReturn;
  Error: () => TReturn;
  Unassigned: (packages: []) => TReturn;
};

export const isLoading = (packages: PackageModel): packages is Loading<object[]> => packages.key === 'Loading';

export const isLoaded = (packages: PackageModel): packages is Loaded<object[]> => packages.key === 'Loaded';

export const matchPackageModel = <TReturn>(options: MatchPackageModelOptions<TReturn>) => (packages: PackageModel) => {
  switch (packages.key) {
    case 'UnassignedPackageModel':
      return options.Unassigned([]);
    case 'Loaded':
      return options.Loaded(packages.Data);
    case 'Loading':
      return options.Loading();
    case 'Conflict':
      return options.Error();
    case 'ServerError':
      return options.Error();
    case 'Unauthorized':
      return options.Error();
  }
};

export const EmptyPackageModel = new UnassignedPackageModel();
